<template>
    <div></div>
</template>

<script>
export default {
    data() {
        return {
            step: 0
        }
    },

    methods: {
        getBlock(keyname) {
            return this.blocks.find(block => block.key === keyname)
        },

        getBlockByStep(step) {
            return this.blocks.find(block => block.step === step)
        },

        nextBlock(keyname) {
            let selectedBlock = this.getBlock(keyname)
            return this.blocks.find(block => block.step === selectedBlock.step + 1)
        },

        changeStep(blockName) {
            let block = this.getBlock(blockName)
            if (block) {
                this.step = this.getBlock(blockName).step
                this.resetSuperiorSteps(block.key)
                this.getBlockByStep(this.step).open = true
                this.getBlockByStep(this.step).result = null
            }
        },

        resetSuperiorSteps(keyname) {
            let block = this.nextBlock(keyname)
            while (block) {
                block.data = null
                block.result = null
                block.closeTitle = null
                block = this.nextBlock(block.key)
            }
        },

        callbackDefault(item, keyname) {
            let block = this.getBlock(keyname)

            // Close current card
            block.result = item
            block.open = false

            // Set CloseTitle
            if (block.result && block.result.length > 0 && block.titleKey) {
                let keys = block.titleKey.split('.')
                let resultTitle = block.result[0]

                keys.forEach((keyname) => {
                    if (resultTitle[keyname]) {
                        resultTitle = resultTitle[keyname]
                    }
                })

                if (resultTitle && typeof resultTitle === 'string') {
                    block.closeTitle = resultTitle
                }
            }

            // Next step
            let nextBlock = this.nextBlock(keyname)
            if (nextBlock) {
                if (nextBlock.init) {
                    this.nextBlock(keyname).init()
                } else {
                    console.warn("Can't find init function for this block")
                }
            }
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/extends/DynamicFormExtension.vue